import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from "@mui/material";

// Sticky bottom action bar shown while a page has unsaved changes. Inverted
// (dark over the cream page) so it reads as its own layer and can't be missed.
const UnsavedChangesBar = ({
  open,
  saving,
  onDiscard,
  onSave,
  saveLabel = "Save Changes",
}) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 16,
        zIndex: (t) => t.zIndex.appBar,
        mt: 3,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1.5,
          px: 2.5,
          py: 1.5,
          borderRadius: 2,
          backgroundColor: "#111008",
          color: "#fefcf7",
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 500, color: "#fefcf7" }}>
          You have unsaved changes
        </Typography>
        <Box sx={{ display: "flex", gap: 1.5 }}>
          <Button
            onClick={onDiscard}
            disabled={saving}
            sx={{
              color: "rgba(254,252,247,0.7)",
              "&:hover": {
                color: "#fefcf7",
                backgroundColor: "rgba(254,252,247,0.08)",
              },
            }}
          >
            Discard
          </Button>
          <Button
            variant="contained"
            onClick={onSave}
            disabled={saving}
            sx={{
              minWidth: 120,
              backgroundColor: "#fefcf7",
              color: "#111008",
              "&:hover": { backgroundColor: "#f2ede2" },
              "&.Mui-disabled": {
                backgroundColor: "rgba(254,252,247,0.3)",
              },
            }}
          >
            {saving ? (
              <CircularProgress size={16} sx={{ color: "#111008" }} />
            ) : (
              saveLabel
            )}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default UnsavedChangesBar;
